import { CONFIRM_ORDER_GET_POST, LANDING_PAGE_ORDER_GET_POST_CONFIRM, VERIFICATION_CODE_GET_POST } from "./APIResources";
import { axiosWithAPIKey } from "../../Services/Axios";
import { APIResponseType } from "../../Services/Models/Async/AsyncModel";

export async function fetchOrderDetails(order_id: string) {
    try {
        let response: APIResponseType<any>;
        await axiosWithAPIKey.get(CONFIRM_ORDER_GET_POST + "?order_id=" + order_id).then((resp: any) => {
            if (resp.data.status) {
                const orderData = resp.data.data;
                response = { success: true, data: orderData, message: "Order details found", code: resp.data.code };
            } else {
                response = { success: false, code: resp.data.code, message: resp.data.message };
            }
        }).catch((error: any) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
        return response!;
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function confirmLPOrder(order_id: string) {
    try {
        let response: APIResponseType<any>;
        await axiosWithAPIKey.put(LANDING_PAGE_ORDER_GET_POST_CONFIRM, { data: [{ order_id: order_id, current_status: "Confirmed" }] }).then((resp: any) => {
            if (resp.data.status) {
                response = { success: true, data: resp.data.data, message: "Order confirmed successfully", code: resp.data.code };
            } else {
                response = { success: false, code: resp.data.code, message: resp.data.message };
            }
        }).catch((error: any) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
        return response!;
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function confirmLPOrderWithConsent(order_id: string, consent: boolean, time_slot: Array<String>) {
    try {
        let response: APIResponseType<any>;
        await axiosWithAPIKey.put(LANDING_PAGE_ORDER_GET_POST_CONFIRM, { data: [{ order_id: order_id, current_status: "Confirmed", consent: consent, time_slot: time_slot.length > 1 ? time_slot.join(' or ') : time_slot[0].toString() }] }).then((resp: any) => {
            if (resp.data.status) {
                response = { success: true, data: resp.data.data, message: "Order confirmed successfully", code: resp.data.code };
            } else {
                response = { success: false, code: resp.data.code, message: resp.data.message };
            }
        }).catch((error: any) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
        return response!;
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function fetchConfirmLPOrder(order_id: string) {
    try {
        let response: APIResponseType<any>;
        await axiosWithAPIKey.get(LANDING_PAGE_ORDER_GET_POST_CONFIRM + "/?order_id=" + order_id).then((resp: any) => {
            if (resp.data.status) {
                const orderData = resp.data.data;
                response = { success: true, data: orderData, message: "Order details found", code: resp.data.code };
            } else {
                response = { success: false, code: resp.data.code, message: resp.data.message };
            }
        }).catch((error: any) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
        return response!;
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function verifyParentEmail (email: string) {
    try {
        let url_data = encodeURIComponent(email);
        return await axiosWithAPIKey.post(`${VERIFICATION_CODE_GET_POST}?email=${url_data}`).then((resp: any) => {
            return { success: true, code: resp.data.data.verification_status };
        }).catch((error: any) => {
           return {success: false, code: error.code || error.toString(), message: error.message || error.toString()}; 
        });
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function verifyParentEmailCode (email: string, code: string) {
    try {
        return axiosWithAPIKey.post(VERIFICATION_CODE_GET_POST, {email, code});
    } catch (error: any) {
        return { status: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}

export async function updateOrderDetails (order_id: string, formData: any) {
    try {
        return await axiosWithAPIKey.post(`${CONFIRM_ORDER_GET_POST}?order_id=${order_id}`, { ...formData }).then((resp: any) => {
            if(resp.data.status && resp.data.code === 200) {
                return { success: true, data: resp.data.data, message: "Order confirmed and updated successfully", code: resp.data.code };
            } else {
                return { success: false, code: "FAIL_ORDER_CONFIRM_UPDATE", message: "Failed to confirm and update order" };
            }
        }).catch((error) => {
            return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
        });
    } catch (error: any) {
        return { success: false, code: error.code || error.toString(), message: error.message || error.toString() };
    }
}